import React, { useCallback, useMemo } from 'react';
import { TextMessage } from '@/components/chat/Message/TextMessage';
import { useMessagesMutation } from '@/hooks/useMessages';
import { type Button, type QuickReplyMessageObject } from '@/types/message.types';
import { type QuickReplyBtnMessageProps } from './types';

export const QuickReplyBtnMessage = React.memo<QuickReplyBtnMessageProps>(
  ({ message }) => {
    const { handleSendMessage } = useMessagesMutation();

    const handleButtonClick = useCallback(
      (button: Button) => {
        handleSendMessage(button.title);
      },
      [handleSendMessage],
    );

    const buttons = useMemo(
      () =>
        (message.extendedMessagePayload?.extendedMessagePayloadDetail
          ?.liveChatV2MessageObject as QuickReplyMessageObject)?.quickReplyMessage?.buttons,
      [
        message.extendedMessagePayload?.extendedMessagePayloadDetail
          ?.liveChatV2MessageObject,
      ],
    );

    return (
      <>
        <TextMessage message={message} />

        {buttons?.length && (
          <div className="sf:flex sf:flex-wrap sf:mt-2 sf:gap-2">
            {buttons?.map((button) => (
              <button
                key={button.id}
                title={button.title}
                aria-label={button.title}
                className="sf:rounded-full sf:border sf:border-widget-button-color sf:bg-white sf:hover:bg-widget-button-color-dimmed sf:px-3 sf:h-[36px] sf:text-widget-button-color sf:text-sm sf:font-semibold sf:cursor-pointer sf:transition-colors sf:duration-150 sf:timing-ease-in-out"
                onClick={() => handleButtonClick(button)}
              >
                {button.title}
              </button>
            ))}
          </div>
        )}
      </>
    );
  },
);

QuickReplyBtnMessage.displayName = 'QuickReplyBtnMessage';
